export class LoginResult {
  private _success: boolean;
  private _error: string;


  constructor(success: boolean, error: string = undefined!) {
    this._success = success;
    this._error = error;
  }


  get success(): boolean {
    return this._success;
  }

  get error(): string {
    return this._error;
  }
}
